import Modal from '../../Basic/Modal/Modal.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import styled from 'styled-components';

const StyledModalContainer = styled(Modal) `
  max-width: 724px;
  align-items: center;
  gap: 1.5rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    gap: 2.5rem;
  }
`;
const StyledList = styled.ul `
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem 0;
  gap: 1rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    margin: 0;
    gap: 1.5rem;
  }
`;
const StyledListLabel = styled.label `
  display: flex;
  gap: 1rem;
  cursor: pointer;
`;
const StyledListItemHeading = styled(Heading) `
  margin: 0;
  font-size: 1rem;
`;
const StyledListItemText = styled(TextComponent) `
  margin: 0;
`;

export { StyledList, StyledListItemHeading, StyledListItemText, StyledListLabel, StyledModalContainer };
//# sourceMappingURL=NewsletterModal.styles.mjs.map
